import {useNavigate, useParams} from "react-router-dom";
import HeaderAIChatbot from '~/components/Layout/components/HeaderAIChatbot';
import React, {Fragment, useRef} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faPaperPlane, faMicrophone, faEllipsis, faPen, faTrash, faEdit} from "@fortawesome/free-solid-svg-icons";
import styles from './AIChatbot.module.scss';
import classNames from "classnames/bind";
import {useEffect, useState} from "react";
import AwsChatbotAPI from '~/api/awsChatbotApi';
import {CenteredModal, TypeWriterText, TypingIndicator} from '~/components';
import {usePlanFeature} from '~/pages/context/PlanFeatureContext';
import {ArrowLeftToLine, ArrowRightToLine, Copy, Volume2Icon, ThumbsUp, ThumbsDown, Repeat, PauseCircle} from "lucide-react";
import {RotatingLines} from "react-loader-spinner";
import {toast} from "react-toastify";
import { v4 as uuidv4 } from 'uuid';
import _ from "lodash";
import {
    startStream,
    pauseStream,
    resumeStream,
    stopStream,
    getState
} from "~/utils/AudioManager";
import useVoiceChatRecorder from "./hooks/useAudioAutoStopRecorder";
import UpgradePlanRequest from './component/UpgradePlanRequest';
import awsChatbotApi from "~/api/awsChatbotApi";
import './wave.css';
import * as signalR from "@microsoft/signalr";
const cx = classNames.bind(styles);
function AIChatbot(){
    const { id } = useParams();
    const [newChat, setNewChat] = useState(false);
    const [sessionsChat, setSessionsChat] = useState([]);
    const [sessionId, setSessionId] = useState(id);
    const [messages, setMessages] = useState([]);
    const [messageInput, setMessageInput] = useState("");
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [sessionTitle, setSessionTitle] = useState("");
    const [sessionTitleInput, setSessionTitleInput] = useState("");
    const [collapse, setCollapse] = useState(false);
    const [activeMessageId, setActiveMessageId] = useState(-1);
    const [isSending, setIsSending] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const [showModalUpgradePlan, setShowModalUpgradePlan] = useState(false);
    const [upgradePlanId, setUpgradePlanId] = useState(0);
    const [showModalRecording, setShowModalRecording] = useState(false);
    const [toggleAudio, setToggleAudio] = useState(null);
    const [playing, setPlaying] = useState(false);
    const [connection, setConnection] = useState(null);
    const textareaRef = useRef(null);
    const chatEndRef = useRef(null);
    const navigate = useNavigate();
    const divRef = useRef(null);
    const {planFeature} = usePlanFeature();
    const chatQuestionsDefault = [
        "What is love?",
        "What is success?",
        "How can you gain long-life success, health, and happiness?",
        "How can I stay healthy?",
        "What is pseudo-success?"
    ];
    const apiUrl = process.env.REACT_APP_API_URL;

    const compareDate = () => {
        const nowUtc = new Date();
        const serverUtcDate = new Date(planFeature.EndDate + "Z");
        return serverUtcDate < nowUtc
    }

    useEffect(() => {
        let connection;
        let audioContext = null;
        let playTime = 0;
        let activeSources = [];

        const ensureAudioContext = () => {
            if (!audioContext || audioContext.state === "closed") {
                audioContext = new AudioContext({ sampleRate: 24000 });
                playTime = audioContext.currentTime;
            }
        };

        const playPcm16Base64 = (base64Pcm) => {
            ensureAudioContext();

            const binary = atob(base64Pcm);
            const bytes = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i++) {
                bytes[i] = binary.charCodeAt(i);
            }

            const pcm16 = new Int16Array(bytes.buffer);
            const float32 = new Float32Array(pcm16.length);
            for (let i = 0; i < pcm16.length; i++) {
                float32[i] = Math.max(-1, Math.min(1, pcm16[i] / 32768));
            }

            const buffer = audioContext.createBuffer(1, float32.length, 24000);
            buffer.copyToChannel(float32, 0);

            const source = audioContext.createBufferSource();
            source.buffer = buffer;
            source.connect(audioContext.destination);

            if (playTime < audioContext.currentTime) {
                playTime = audioContext.currentTime;
            }

            source.start(playTime);
            playTime += buffer.duration;

            // 🔥 QUAN TRỌNG
            activeSources.push(source);

            source.onended = () => {
                activeSources = activeSources.filter(s => s !== source);
            };
        }

        const start = async () => {
            connection = new signalR.HubConnectionBuilder()
                .withUrl(`${apiUrl}/voiceChatHub`, { withCredentials: true })
                .withAutomaticReconnect()
                .build();

            // ===== TEXT =====
            connection.on("ReceiveTextVoiceChat", (text) => {
                console.log("TEXT:", text);
            });

            // ===== TTS AUDIO (Realtime) =====
            connection.on("ReceiveAudioChunkVoiceChat", (base64Pcm) => {
                console.log(base64Pcm)
                playPcm16Base64(base64Pcm);
            });

            // ===== OPTIONAL: legacy / fallback audio =====
            connection.on("ReceiveAudioChunk", (base64Pcm) => {
                playPcm16Base64(base64Pcm);
            });

            connection.on("TtsCompleted", () => {
                console.log("TTS finished");
            });

            connection.on("ReceiveActionVoiceChat", (actionName) => {
                console.log("TEXT:", actionName);
                if(actionName === "stop") {
                    activeSources.forEach(src => {
                        try {
                            src.stop();
                            src.disconnect();
                        } catch {}
                    });

                    activeSources = [];

                    if (audioContext) {
                        playTime = audioContext.currentTime;
                    }
                }
            });

            try {
                await connection.start();
                console.log("SignalR connected");
                setConnection(connection);
            } catch (err) {
                console.error("SignalR connect error", err);
            }
        };

        start();

        return () => {
            if (connection) {
                connection.stop();
            }
            if (audioContext && audioContext.state !== "closed") {
                audioContext.close();
            }
        };
    }, []);

    const { startRecording, stopRecording } = useVoiceChatRecorder(connection);

    useEffect(() => {
        AwsChatbotAPI.getChatSessionByUserId()
            .then((res) => {
                const grouped = _.groupBy(res.data, "Classifications");
                setSessionsChat(grouped);
            })
            .catch((err) => {
            });
    }, [sessionTitle]);

    useEffect(() => {
        if(sessionId && !newChat){
            const params = new URLSearchParams({
                userId: "0",
                sessionId: sessionId,
            });
            AwsChatbotAPI.getChatHistoryBySessionId(params)
                .then((res) => {
                    const parsedData = res.data.map(item => ({
                        ...item,
                        ShowButtons: true,
                        ChatButtons:
                            item.ChatButtons && item.ChatButtons.startsWith("[")
                                ? JSON.parse(item.ChatButtons)
                                : []
                    }));
                    setMessages(parsedData);
                    if(res.data.length <= 0){
                        navigate('/ai-chatbot/chat', { replace: true });
                    }
                })
                .catch((err) => {
                });
        }
        else {
            if(newChat){
                setNewChat(false);
            }
            setMessages([])
        }
        const el = divRef.current;
        if (el) {
            const style = window.getComputedStyle(el);
            if (style.display === "none") {
                handleToggleCollapse();
            }
        }

    }, [sessionId]);


    const handleInput = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = "auto"; // reset
            textarea.style.height = Math.min(textarea.scrollHeight, 130) + "px";
        }
    };

    const handleMessageInput = async (message, isMessageInput, messageValue) => {
        if(compareDate())
        {
            setUpgradePlanId(1);
            setShowModalUpgradePlan(true);
            return;
        }
        if (isTyping) {
            return;
        }
        setIsTyping(true);
        const trimmed = message.trim();
        if (!trimmed) return;
        let newSessionId = '';
        if(messages.length <= 0){
            setNewChat(true);
            newSessionId = uuidv4();
            setSessionId(newSessionId);
            window.history.pushState({}, "", `/ai-chatbot/chat/${newSessionId}`);
            const data = {
                SessionId: newSessionId,
                Title: message.substring(0, 100)
            }
            await AwsChatbotAPI.insChatSessionTitle(data);
            setSessionTitle(message.substring(0, 100));
        }

        setMessages((prev) => [
            ...prev,
            { ChatTypeId: 1, ChatContent: trimmed },
        ]);
        const dataInsert = {
            SessionId: newSessionId === '' ? sessionId : newSessionId,
            ChatContent: trimmed,
            ChatTypeId: 1,
        }
        AwsChatbotAPI.insAwsChatHistory(dataInsert);
        if(isMessageInput){
            setMessageInput("");
        }
        await handleRecognizeTextAsync(trimmed, newSessionId === '' ? sessionId : newSessionId, messageValue, isMessageInput);
    }

    const handleSendMessage = async () => {
        await handleMessageInput(messageInput, true, messageInput);
    }

    const handleRecognizeTextAsync = async (textInput, currentSessionId, messageValue, isMessageInput) => {
        if (textInput === "") return;
        setIsSending(true);

        let chatContent = "";
        let newButtons = [];

        awsChatbotApi.getAnswer({TextInput : textInput, TextValue: isMessageInput ? "" : messageValue})
            .then(async (res) => {
                const resData = res.data;
                if (resData.IsRandomText){
                    chatContent = "Looks like you might have typed something by mistake! How can I help you today?";
                    newButtons = [];
                }
                else {
                    chatContent = resData.ContentTranslate;
                    newButtons = resData.ButtonListTranslate.map(item => ({
                        Text: item.text,
                        Value: item.value
                    }));
                }
            })
            .catch((err) => {
                chatContent = "Looks like you might have typed something by mistake! How can I help you today?";
                newButtons = [];
            })
            .finally(() => {
                setIsSending(false);
                setMessages((prev) => [
                    ...prev,
                    {
                        ChatTypeId: 2,
                        ChatContent: chatContent,
                        ChatButtons: newButtons,
                        IsNew: true,
                        ShowButtons: false,
                    },
                ]);
                const data = {
                    SessionId: currentSessionId,
                    ChatContent: chatContent,
                    ChatTypeId: 2,
                    ChatButtons: JSON.stringify(newButtons)
                }
                AwsChatbotAPI.insAwsChatHistory(data)
            })
    }

    useEffect(() => {
        chatEndRef.current?.scrollIntoView({ behavior: "smooth", block: 'end' });
    }, [messages]);

    const handleKeyDown = async (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            await handleSendMessage();
        }
    };

    const handleChatButton = async (buttonValue, buttonText) => {
        await handleMessageInput(buttonText, false, buttonValue);
    };

    const handleConfirmDelete = () => {

    }

    const handleConfirmEdit = () => {
        if(sessionTitleInput.trim() === "") return;

        const data = {
            SessionId: sessionId,
            Title: sessionTitleInput.trim()
        }
        AwsChatbotAPI.updChatSessionTitle(data)
            .then((res) => {
                setSessionTitle(sessionTitleInput.trim());
                toast.success(<span className="fs-9 fw-bold">Title has been updated.</span>);
            })
            .catch((err) => {
                toast.error(<span className="fs-9 fw-bold">An error occurred while updating title.</span>)
                ;
            })
            .finally(() => {
                setShowModalEdit(false);
            })
        ;
    }

    const handleNewChatSession = () => {
        setSessionId("");
        navigate('/ai-chatbot/chat', { replace: true });
    }

    const handleToggleCollapse = () => {
        const html = document.documentElement; // <html>
        html.classList.toggle("navbar-vertical-collapsed");
        setCollapse(prev => !prev);
    }

    const handleMessageClick = (index) => {
        if(isTyping) return;
        if(activeMessageId === index || window.innerWidth > 768) return;
        setActiveMessageId(index);
    }

    const handleMouseEnter = (index) => {
        if(isTyping) return;
        if(window.innerWidth > 768){
            setActiveMessageId(index);
        }
    }
    const handleMouseLeave = () => {
        if(isTyping) return;
        if(window.innerWidth > 768){
             setActiveMessageId(null);
             setToggleAudio(null);
        }
    }

    const handleCopyMessage = (messageContent) => {
        navigator.clipboard.writeText(messageContent)
            .then(() => {
            })
            .catch(err => {
            });
    };

    const handleTextToSpeech = (messageContent, messageId) => {

        const {isPlaying, isPaused } = getState(messageId);

        if (isPlaying) {
            pauseStream();
            return;
        }

        if (isPaused) {
            resumeStream();
            return;
        }

        stopStream();
        startStream(messageId);
        setToggleAudio(prev => !prev);
        connection.invoke("StartTextToSpeech", messageContent);
    };

    const handleVoiceChat = () => {
        setShowModalRecording(true);
    }

    const handleRepeatMessage = (messageContent) => {
        setMessageInput(messageContent);
    }

    const updateMessageAtIndex = (index, updates) => {
        setMessages((prev) =>
            prev.map((msg, i) => (i === index ? { ...msg, ...updates } : msg))
        );
    };

    const renderMessage = (message, index) => {
        if (message.ChatTypeId === 1) {
            return (
                <div key={index} className="d-flex chat-message flex-column align-items-end pb-4"
                     onMouseEnter={() => handleMouseEnter(index)}
                     onMouseLeave={() => handleMouseLeave(index)}
                     onClick={() => handleMessageClick(index)}
                >
                    <div className={cx("right-message", "chat-message-content", "fs-8-1", "border")}>
                        {message.ChatContent}
                    </div>
                    {
                        activeMessageId === index && (
                            <div className='cursor-pointer my-1'>
                                <Copy size={14} className="me-3"
                                      onClick={() => handleCopyMessage(message.ChatContent)}
                                />
                                <Repeat size={14} className="me-3"
                                        onClick={() => handleRepeatMessage(message.ChatContent)}
                                />
                            </div>
                        )
                    }
                </div>
            );
        }

        return (
            <div key={index} className="d-flex chat-message pb-4 flex-column"
                 onMouseEnter={() => handleMouseEnter(index)}
                 onMouseLeave={() => handleMouseLeave(index)}
                 onClick={() => handleMessageClick(index)}
            >
                <div className={cx("chat-message-content", "fs-8-1")}>
                    {message.IsNew ? (
                        <TypeWriterText
                            text={message.ChatContent}
                            onComplete={() => {
                                updateMessageAtIndex(index, {
                                    IsNew: false,
                                    ShowButtons: true
                                })
                                setIsTyping(false);
                                scrollToBottom();
                            }}
                        />
                    ) : (
                        message.ChatContent
                    )}
                </div>

                {
                    message.ShowButtons && message.ChatButtons && (
                        <div className={cx("chat-buttons", "d-flex mt-2 mb-2")}>
                            {message.ChatButtons.map((button, idx) => (
                                <div
                                    key={idx}
                                    title={button.Text}
                                    className={cx("chat-button", "fs-8-1 border", "cursor-pointer")}
                                    onClick={() => handleChatButton(button.Value, button.Text)}
                                >
                                <span className={cx("button-text", "fs-9", "fw-bold")}>
                                  {button.Text}
                                </span>
                                </div>
                            ))}
                        </div>
                    )
                }

                {
                    (activeMessageId === index || toggleAudio) && (
                        <div className='cursor-pointer my-1 d-flex'>
                            <Copy size={14} className="me-3" onClick={() => handleCopyMessage(message.ChatContent)}/>
                            {getState(index).isPlaying ? (
                                <PauseCircle
                                    size={14}
                                    className="me-3"
                                    onClick={() => handleTextToSpeech(message.ChatContent, index)}
                                />
                            ) : getState(index).isLoading ? (
                                <RotatingLines
                                    height="16"
                                    width="16"
                                    color="grey"
                                    wrapperClass="me-3"
                                    strokeWidth="4"
                                />
                            ) : (
                                <Volume2Icon
                                    size={14}
                                    className="me-3"
                                    onClick={() => handleTextToSpeech(message.ChatContent, index)}
                                />
                            )}
                            <ThumbsUp size={14} className="me-3"/>
                            <ThumbsDown size={14} className="me-3"/>
                        </div>
                    )
                }
            </div>
        );
    };

    const handleStartVoiceChat = (isStart) => {
        if (isStart) {
            startRecording();
        }
        else {
            stopRecording();
        }
        setPlaying(isStart);
    }

    const handleCloseVoiceChat = () => {
        setShowModalRecording(false);
        setPlaying(false);
    }

    const scrollToBottom = () => {
        chatEndRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "end"
        });
    };

    if(planFeature.CurrentServicePlanId === 0)
    {
        navigate('/auth/locked-screen', { replace: true });
    }

    return (
        <Fragment>
            {
                planFeature.CurrentServicePlanId > 0 &&
                <Fragment>
                    <nav className="navbar navbar-vertical navbar-expand-lg">
                        <div className='navbar-collapse collapse show' id='navbarVerticalCollapse'>
                            {
                                !collapse && (
                                    <div className={`navbar-vertical-content`}>
                                        <ul className="navbar-nav flex-column" id='navbarVerticalNav'>
                                            <li className='nav-item'>
                                                <div className="nav-item-wrapper">
                                                    <div
                                                        className="nav-link ps-2 pt-2 pb-2 d-flex align-items-center justify-content-between cursor-pointer mb-1"
                                                        style={{border: "1px solid #eff2f6"}}
                                                        onClick={handleNewChatSession}>
                                                        <div>
                                                            <FontAwesomeIcon icon={faEdit} className="fs-8 me-2"/>
                                                            <span className="pt-1 fs-8-1">New Chat</span>
                                                        </div>
                                                        <span className="pt-1 float-end fs-9" style={{color: "#cdcdcd"}}>Ctrl + Shift + O</span>
                                                    </div>
                                                </div>
                                            </li>
                                            <li className='nav-item'>
                                                {Object.keys(sessionsChat).map((classification) => (
                                                    <div key={classification}>
                                                        <p className="navbar-vertical-label">{classification}</p>
                                                        <hr className="navbar-vertical-line"/>
                                                        {
                                                            sessionsChat[classification].map((session) => (
                                                                <div key={session.AwsChatSessionId}
                                                                     className={cx(`${session.SessionId === sessionId ? 'active-session' : ""}`, `nav-link ps-2 pt-1 pb-1 d-flex align-items-center cursor-pointer mb-1`)}
                                                                     onClick={() => {
                                                                         setSessionId(session.SessionId);
                                                                         window.history.pushState({}, "", `/ai-chatbot/chat/${session.SessionId}`);
                                                                     }}>
                                                                    <span
                                                                        className={cx("session-title")}>{session.Title}</span>
                                                                    <div className={cx("dropdown", "session-title-action")}>
                                                                        <button
                                                                            className="btn fs-10 btn-sm dropdown-toggle dropdown-caret-none transition-none"
                                                                            type="button" data-bs-toggle="dropdown"
                                                                            data-boundary="window" aria-haspopup="true"
                                                                            aria-expanded="false"
                                                                            data-bs-reference="parent">
                                                                            <FontAwesomeIcon icon={faEllipsis}
                                                                                             className='me-1'/>
                                                                        </button>
                                                                        <div
                                                                            className={cx("dropdown-menu-action", "dropdown-menu", "dropdown-menu-end", "py-2")}>
                                                                            <span className="dropdown-item"
                                                                                  onClick={() => {
                                                                                      setShowModalEdit(true);
                                                                                      setSessionTitleInput(session.Title);
                                                                                  }}
                                                                            >
                                                                                Edit
                                                                                <FontAwesomeIcon icon={faPen}
                                                                                                 className='float-end'/>
                                                                            </span>
                                                                            <span className="dropdown-item"
                                                                                  onClick={() => setShowModalDelete(true)}>
                                                                                Delete
                                                                                <FontAwesomeIcon icon={faTrash}
                                                                                                 className='float-end'/>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                ))}
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }
                        </div>
                        <div className="navbar-vertical-footer" ref={divRef}>
                            <button onClick={handleToggleCollapse}
                                    className="btn navbar-vertical-toggle border-0 fw-semibold w-100 white-space-nowrap d-flex align-items-center">
                                <ArrowLeftToLine size={19}/>
                                <ArrowRightToLine size={19}/>
                                <span className="navbar-vertical-footer-text ms-2">Collapsed</span>
                            </button>
                        </div>
                    </nav>
                    <HeaderAIChatbot isShowButtonToggle={true} toggleOnClick={handleToggleCollapse}/>
                    <div className={cx('chat-container', 'content pe-3 ps-3')}>
                        <div className={cx('chat-container__body', 'scrollbar')}>
                            <div className={cx('chat-content')} ref={chatEndRef}>
                                {
                                    messages.length > 0 ?
                                        (
                                            <Fragment>
                                                {messages.map((message, index) => renderMessage(message, index))}
                                                {isSending && (
                                                    <div className="d-flex chat-message pb-4 flex-column">
                                                        <div className={cx("chat-message-content", "fs-8-1")}>
                                                            <TypingIndicator/>
                                                        </div>
                                                    </div>
                                                )}
                                                <div style={{height: "150px"}}></div>
                                            </Fragment>
                                        )
                                        :
                                        (
                                            <div style={{marginTop: "30vh"}}>
                                                <h4 className="mb-3 text-center">What can I help with?</h4>
                                                <div className="d-flex justify-content-center">
                                                    <div
                                                        className={cx("chat-buttons", "d-flex mt-2 mb-2 justify-content-center")}>
                                                        {chatQuestionsDefault.map((question, index) => (
                                                            <div
                                                                key={index}
                                                                title={question}
                                                                className={cx("chat-button", "fs-8-1 cursor-pointer border")}
                                                                onClick={() => handleChatButton(question, question)}
                                                            >
                                                                <span className={cx("button-text", "fs-9 fw-bold")}>
                                                                  {question}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                }
                            </div>
                        </div>
                        <div className={cx('chat-footer', 'w-100')}>
                            <div className={cx('chat-textarea-container', 'bg-body-emphasis')}>
                        <textarea ref={textareaRef} onInput={handleInput} placeholder="Type message here..."
                                  className={cx('chat-textarea', 'fs-8-1 ps-2 scrollbar')}
                                  value={messageInput} onChange={(e) => setMessageInput(e.target.value)}
                                  onKeyDown={handleKeyDown}/>
                                <div className='d-flex justify-content-end'>
                                    {/*<div className={cx('icon-action')} onClick={handleVoiceChat}>*/}
                                    {/*    <FontAwesomeIcon className="fs-9" icon={faMicrophone}/>*/}
                                    {/*</div>*/}
                                    <div className={cx('icon-action', 'me-3')} onClick={handleSendMessage}>
                                        <FontAwesomeIcon className="fs-9" icon={faPaperPlane}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <CenteredModal show={showModalDelete} title="Delete chat" onClose={() => setShowModalDelete(false)}
                                   confirmText="Delete" onConfirm={handleConfirmDelete}>
                        <span className="fs-9 fw-bold">Are you sure you want to remove this chat?</span>
                    </CenteredModal>

                    <CenteredModal show={showModalEdit} title="Edit chat title" onClose={() => setShowModalEdit(false)}
                                   confirmText="Save Changes" onConfirm={handleConfirmEdit}>
                        <div className="form-icon-container">
                            <div className="form-floating">
                                <input value={sessionTitleInput} className="form-control form-icon-input"
                                       id="emailSocial" type="email" placeholder="Email"
                                       onChange={(e) => setSessionTitleInput(e.target.value)}/>
                                <label className="text-body-tertiary form-icon-label" htmlFor="emailSocial">ENTER NEW
                                    TITLE</label>
                            </div>
                            <FontAwesomeIcon icon={faPen} className='form-icon fs-9 text-body'/>
                        </div>
                    </CenteredModal>

                    <UpgradePlanRequest typeId={upgradePlanId} setShowModal={setShowModalUpgradePlan} showModal={showModalUpgradePlan}/>

                    <CenteredModal
                        show={showModalRecording}
                        title=""
                        onClose={() => setShowModalRecording(false)}
                        closeText=""
                        modalType="modal-fullscreen"
                        modalContentClass="opacity-85"
                    >
                        <div className="d-flex h-70 justify-content-center align-items-center">
                            <div className={`speaker ${playing ? "active" : "paused"}`}>
                                <span className="wave"></span>
                                <span className="wave"></span>
                                <span className="wave"></span>
                                <span className="wave big"></span>
                                <span className="wave big"></span>
                                <div className="core"></div>
                            </div>
                        </div>
                        <p className="fs-9 text-center">
                            Press Start to begin speaking and Stop to finish and wait for the system’s response. <br/>
                            The system will automatically stop if you remain silent for 10 seconds.
                        </p>
                        <div className="text-center">
                            <button onClick={() => handleStartVoiceChat(true)} className="btn-speaker me-4 bg-success fw-bold text-white">Start</button>
                            <button onClick={() => handleStartVoiceChat(false)} className="btn-speaker me-4 bg-danger fw-bold text-white">Stop</button>
                            <button onClick={handleCloseVoiceChat} className="btn-speaker fw-bold">Close</button>
                        </div>
                    </CenteredModal>
                </Fragment>
            }
        </Fragment>
    )
}

export default AIChatbot
